<template>
  <div class="base-wrapper">
    <div ref="sidebar" class="sidebar-container" :class="{ 'is-unfold': isUnfold }">
      <div class="logo-wrapper">
        <AppLink :disabled="dashboardDisabled" :to="userId ? '/' : '/map/index'" class="logo-container">
          <img class="logo" src="@/assets/img/share-icon/glypha-avanced.svg" alt="" />
        </AppLink>
      </div>
      <Freemium :is-unfold="isUnfold"></Freemium>
      <TrialControl :is-unfold="isUnfold" />
      <BetaControl :is-unfold="isUnfold" />
      <div class="sidebar-wrapper" :class="{ 'sidebar-hint': sidebarShowHint, 'sidebar-scroll': isScroll && isUnfold }">
        <div :class="{
        'sidebar-content': true,
      }" @scroll="sidebarScroll">
          <Mission :is-unfold="isUnfold" v-if="!quickOnboardStatus && userId"></Mission>
          <div :class="{
          'sidebar-item-wrapper': true,
          'fold-sidebar-wrapper': isUnfold
        }">
            <SidebarItem
                v-for="item in routes"
                :key="item.path"
                :route="item"
                :base-path="item.path"
                :active-path="activePath"
                :is-unfold="isUnfold"
            />
          </div>
        </div>
      </div>
      <div class="booking-container" @click="bookMeetingClick">
        <app-link
          to="https://outlook.office365.com/owa/calendar/Bookings-TruckerPathCommandTraining@renren-inc.com/bookings/"
          :class="{
            'item-link-wrapper': true,
          }"
        >
          <item
            class="item-link"
            icon="booking-icon"
            title="Book Training"
          />
        </app-link>
      </div>
      <div class="help-container">
        <app-link
          to="https://helpcenter.truckerpath.com/hc/en-us/categories/8499099924365-Command"
          :class="{
            'item-link-wrapper': true,
          }"
        >
          <item
            class="item-link"
            icon="help-v2"
            title="Help Center"
          />
        </app-link>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
import _find from 'lodash/find'
import SidebarItem from './sidebar-item'
import AppLink from "./link"
import Item from './item.vue'
import TrialControl from './trial'
import BetaControl from './beta'
import Freemium from './freemium.vue'
import Mission from './mission.vue'

import appendToDom from "@/components-v3/mixins/append-to-dom"

export default {
  components: {AppLink, Item, SidebarItem, TrialControl, BetaControl, Freemium, Mission},
  mixins: [appendToDom(document.getElementById('side-bar'))],
  data() {
    return {
      isUnfold: false,
      activePath: '',
      timeout: null,
      isScroll: false,
      setTimeId: null
    }
  },
  watch: {
    '$route': {
      handler(newVal) {
        if (newVal.name === 'SelfOrder') {
          this.activePath = newVal.query.redirect || newVal.meta.activeMenu
        } else {
          this.activePath = newVal.meta && newVal.meta.activeMenu ? newVal.meta.activeMenu : newVal.path
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.$refs.sidebar.addEventListener('mouseenter', this.mouseoverFn)
    this.$refs.sidebar.addEventListener('mouseleave', this.mouseoutFn)
    let sidebarWrapper = document.querySelector(".sidebar-wrapper");
    if(this.userId) {
      sidebarWrapper.style.height = `calc(100% - ${72 + 54 + 54 + this.topHeight + "px"})`;
    }
  },
  beforeDestroy() {
    this.$refs.sidebar.removeEventListener('mouseenter', this.mouseoverFn)
    this.$refs.sidebar.removeEventListener('mouseleave', this.mouseoutFn)
  },
  computed: {
    ...mapGetters('user', [
      'userId',"topHeight"
    ]),
    ...mapState({
      routes: state => state.permissionV2.routes,
      demoType: state => state.user.demoType,
      expiredDemoAccount: state => state.user.expiredDemoAccount,
      quickOnboardStatus: state => state.user.quickOnboardStatus
    }),
    dashboardDisabled() {
      try {
        let home = _find(this.routes, item => item.path === '/')
        let dashboardRoute = _find(home.children, item => item.path === 'dashboard')
        return dashboardRoute.disabled
      } catch {
        return false
      }
    },
    sidebarShowHint() {
      // trial用户提示
      if (this.demoType === 'trial') return true
      // beta过期还未延长15天时提示
      if (this.demoType === 'demo' && this.expiredDemoAccount) return true
      // beta延长15天后提示
      if (this.demoType === 'demo_trail') return true
      if (this.demoType === 'freemium') return true
      return false
    }
  },
  methods: {
    ...mapMutations("user", [
      "SET_SIDEBAR_IS_UNFOLD",
    ]),
    ...mapActions({
      logout: 'user/logout'
    }),
    sidebarScroll(ev) {
      console.log(ev)
      const scrollTop = ev.target.scrollTop
      if (!scrollTop) {
         this.isScroll = false
         clearTimeout(this.setTimeId)
         return
      }
      this.isScroll = true
      clearTimeout(this.setTimeId)
      this.setTimeId = setTimeout(() => {
        this.isScroll = false
      }, 300)
    },
    point() {
      this.$buriedPoints(1.3)
    },
    mouseoverFn() {
      this.timeout = setTimeout(() => {
        this.isUnfold = true
        this.SET_SIDEBAR_IS_UNFOLD(true);
        clearTimeout(this.timeout)
        this.timeout = null
      }, 200)
    },
    mouseoutFn() {
      if (this.timeout) {
        clearTimeout(this.timeout)
        this.timeout = null
      }
      this.isUnfold = false
      this.SET_SIDEBAR_IS_UNFOLD(false);
    },
    bookMeetingClick() {
      this.$buriedPoints(22.1, {
        Source: "Sidebar"
      })
      localStorage.setItem(`bookingsLinkIsopen${this.userId}`, "true");
    }
  }
}
</script>
<style lang="scss" scoped>
.base-wrapper {
  width: 72px;
  height: 100%;
  overflow: visible;
}
.sidebar-container {
  height: 100%;
  width: 72px;
  background-color: #001c4f;
  z-index: 2001;
  overflow: hidden;
  transition: 0.1s width ease-in-out;


  &.is-unfold {
    width: 240px;
    .logo-container .logo {
      width: 135px;
    }
  }
  .logo-wrapper {
    width: 100%;
    height: 72px;
    padding: 20px;
  }
  .logo-container {
    display: block;
    // margin-left: 6px;
    .logo {
      cursor: pointer;
      width: 32px;
      height: 32px;
      object-fit: cover;
      object-position: top left;
      transition: 0.1s width ease-in-out;
    }
  }
  .sidebar-content {
    // margin-top: 12px;
    height: 100%;
    overflow-y: auto;
    overflow-y: overlay;
    overflow-x: hidden;
    padding: 0 0 10px 0;
    background: #001c4f;

    &::-webkit-scrollbar {
      width: 10px;
      height: 100%;
      display: block;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 6px;
      box-shadow: 8px 0 0 rgba(#FFF, 0.3) inset;
      border-width: 2px 2px;
      border-style: solid;
      border-color: #001c4f;

      &:hover {
        box-shadow: 8px 0 0 rgba(#FFF, 0.5) inset;
      }
    }

    &::-webkit-scrollbar-track {
      background-color: rgba(0, 0, 0, 0);
    }

    .sidebar-item-wrapper {
      width: 72px;
    }
    .fold-sidebar-wrapper {
      width: 240px;
    }
  }
  .sidebar-wrapper {
    position: relative;
     height: calc(100% - 72px - 54px - 54px);
     &::before{
        content: '';
        top: 0;
        height: 0;
        left: 0;
        right: 0;
        transition: height 0.2s;
        position: absolute;
        background: url('~@/assets/img/tp-header/side-bar-shadow.svg') no-repeat;
     }
  }
  .sidebar-scroll{
    &::before{
      height: 32px;
      
    }
  }

  .sidebar-hint {
    height: calc(100% - 72px - 54px - 36px);
  }
  .help-container,
  .booking-container {
    position: relative;
    height: 54px;
    padding: 0 12px 10px;
    
  }
  .booking-container {
    &::before {
      content: '';
      position: absolute;
      top: -34px;
      left: 0;
      right: 0;
      height: 34px;
      background: linear-gradient(180deg, rgba(0, 28, 79, 0) 0%, #001C4F 100%);
    }
  }
}
</style>
